import { useSwitchBreakpoint } from 'presentation/hooks/useSwitchBreakpoint'

export const useNearbyBuyersMarkerPopupWidth = () =>
  useSwitchBreakpoint({
    mobSm: 272,
    tabSm: 336,
  }) ?? 336
